import { render, staticRenderFns } from "./PrivacyPolicyVpc.vue?vue&type=template&id=7d0fb4b5"
import script from "./PrivacyPolicyVpc.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyVpc.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyVpc.vue?vue&type=style&index=0&id=7d0fb4b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports